/* eslint-disable */
// Amplify Auth's config: the stage's Cognito pool and web client
// (src/stage-config.js, TT-1248).

import stageConfig from "./stage-config";

const awsconfig = {
  aws_project_region: "us-west-2",
  aws_cognito_region: "us-west-2",
  aws_user_pools_id: stageConfig.userPoolId,
  aws_user_pools_web_client_id: stageConfig.userPoolWebClientId,
  oauth: {},
};

export default awsconfig;
